import "../App.css";
import "../styles/login.css";
import Parametros from "./Parametros";
import * as msal from "@azure/msal-browser";

const azureEnabled = Parametros.enabledProviders.includes("azure");

const msalInstance = azureEnabled
  ? new msal.PublicClientApplication(Parametros.msalConfigClientSilentToken)
  : null;

const azureScope = process.env.REACT_APP_AZURE_API_SCOPE;
const accessTokenRequest = msalInstance
  ? {
      scopes: azureScope ? [azureScope] : [],
      account: msalInstance.getAllAccounts()[0],
    }
  : null;

const decodeJwt = (token) => {
  try {
    const parts = (token || "").split(".");
    if (parts.length !== 3) return null;
    const payload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(payload));
  } catch (e) {
    return null;
  }
};

// Detecta el provider de la sesión actual mirando el `iss` del JWT en
// localStorage. Permite que coexistan Azure (Madlex) y SAML (Yagabogados)
// en el mismo deploy sin necesidad de variables de configuración extra.
const providerOfStoredToken = () => {
  const claims = decodeJwt(localStorage.getItem("jwt"));
  if (!claims || !claims.iss) return null;
  if (claims.iss.startsWith("https://login.microsoftonline.com/")) return "azure";
  if (claims.iss === "madlex-crm") return "saml";
  return null;
};

let getSilentKey = async () => {
  if (providerOfStoredToken() === "azure" && msalInstance) {
    return await msalInstance.acquireTokenSilent(accessTokenRequest);
  }
  // SAML (o sesión nueva): el JWT propio ya vive en localStorage post-callback.
  return localStorage.getItem("jwt");
};

const tokenAndEmail = (loginResponse) => {
  // Azure: viene el objeto MSAL completo
  if (loginResponse && typeof loginResponse === "object" && loginResponse.accessToken) {
    return {
      token: loginResponse.accessToken,
      email:
        (loginResponse.account && loginResponse.account.username) ||
        (decodeJwt(loginResponse.accessToken) || {}).preferred_username,
    };
  }
  // SAML: viene el JWT string directo
  if (typeof loginResponse === "string") {
    const claims = decodeJwt(loginResponse) || {};
    return { token: loginResponse, email: claims.email };
  }
  return { token: null, email: null };
};

let reloadUser = async (loginResponse) => {
  const { token, email } = tokenAndEmail(loginResponse);
  if (!token || !email) return null;

  const response = await fetch(
    Parametros.urlApi + "users/info?email=" + email,
    {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
  const loginResponseUser = await response.json();
  if (response.status !== 200) {
    alert(loginResponseUser.detail);
    return null;
  }

  // Para Azure preservamos el objeto MSAL original (lo usa UserTab para .account).
  // Para SAML armamos un objeto compatible.
  const enriched =
    typeof loginResponse === "object" && loginResponse !== null
      ? loginResponse
      : { accessToken: token, email };
  enriched.hmcyaUsers = loginResponseUser;
  enriched.key = token;
  enriched.email = email;
  enriched.crear = "Falta permiso para crear";
  enriched.editar = "Falta permiso para editar";
  enriched.eliminar = "Falta permiso para eliminar";
  enriched.ver = "Usted no tiene permisos para ver esto";

  let listaFiltradaPer = [];
  enriched.hmcyaUsers.profiles.map((item) => {
    return item.actions.map((action) => {
      return listaFiltradaPer.push(action.decription);
    });
  });
  enriched.permisos = [...new Set(listaFiltradaPer)];

  let listaFiltradaModulos = [];
  enriched.modulos =
    enriched.hmcyaUsers.profiles.length > 0
      ? enriched.hmcyaUsers.profiles.map((item) => {
          return item.modules.map((modulo) => {
            return listaFiltradaModulos.push(
              modulo.module === "Detalle Causa" && modulo.submodule
            );
          });
        })[0]
      : [];
  enriched.modulos = [...new Set(listaFiltradaModulos)];

  let listaFiltradaModulosAdmins = [];
  enriched.modulosAdministracion =
    enriched.hmcyaUsers.profiles.length > 0
      ? enriched.hmcyaUsers.profiles.map((item) => {
          return item.modules.map((modulo) => {
            return listaFiltradaModulosAdmins.push(
              modulo.module === "Administrador" && modulo.submodule
            );
          });
        })[0]
      : [];
  enriched.modulosAdministracion = [...new Set(listaFiltradaModulosAdmins)];

  localStorage.setItem("usuario", JSON.stringify(enriched));
  return enriched;
};

const user = () => {
  return JSON.parse(localStorage.getItem("usuario"));
};

// eslint-disable-next-line
export default { reloadUser, user, getSilentKey, providerOfStoredToken };
